// extracted by mini-css-extract-plugin
module.exports = {"block":"GradientBgBlock_block__Y_C_7"};